import { render, staticRenderFns } from "./PageBottomSheet.vue?vue&type=template&id=2d8ff88a&"
import script from "./PageBottomSheet.vue?vue&type=script&lang=js&"
export * from "./PageBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./PageBottomSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VSheet})
